export default {
  methods: {
    camelize: (text, separator = '-') => (
      text.split(separator)
        .map(w => w.replace(/./, m => m.toUpperCase()))
        .join('')
    )
  }
}
